import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para agregar token en headers
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const PostAmoxarifado = async (datos) => {
  try {
    const response = await api.post('registroProductoAmoxarifado', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostCategory = async (datos) => {
  try {
    const response = await api.post('categoriasDeposito', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostSubCategory = async (datos) => {
  try {
    const response = await api.post('subcategoriasDeposito', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostDeposito = async (datos) => {
  try {
    const response = await api.post('registroDepositoAmoxarifado', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostDepositoRandom = async (datos) => {
  const usuarioId = Number(secureStorage.getItem("id"));

  const dataSubmitted = datos.map((item) => ({
    ...item,
    id_usuario: usuarioId,
  }));


  try {
    const response = await api.post('salidaRandom', dataSubmitted);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};




const getCategoriasAmoxarifado = async () => {
  try {
    const response = await api.get('obtenerCategoria'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

export const getStockMinimo = async () => {
  try {
    const response = await api.get('getStockMinimo'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getDepositoAmoxarifado = async () => {
  try {
    const response = await api.get('obtenerDeposito'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getProductoAmoxarifado = async () => {
  try {
    const response = await api.get('obtenerProducto'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getStockAmoxarifado = async () => {
  try {
    const response = await api.get('getStockDep'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getPrestamoAmoxarifado = async () => {
  try {
    const response = await api.get('getPrestamoDep'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getHistorialDeposito = async () => {
  try {
    const response = await api.get('getHistorialDep'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getOneSubCategoriasAmoxarifado = async (id_categoria) => {
  try {
    const response = await api.get(`obtenersubCategoria/${id_categoria}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getOneProductoDepositoView = async (serie) => {
  try {
    const response = await api.get(`obtenerDepositoView/${serie}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

// const getOneProductoDeposito = async (serie) => {
//   try {
//     const response = await api.get(`obtenerDepositoView/${serie}`); 
//     return response.data;
//   } catch (error) {
//     console.error('Error al obtener productos tejidos:', error);
//     throw error;
//   }
// };

const getOneSerieDep = async (serie) => {
  try {
    const response = await api.get(`obtenerDepositoView/${serie}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};


const getOneProductoDeposito = async (serie) => {
  try {
    const response = await api.get(`obtenerProductoSerie/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Paquete no encontrado ', error);
  }
}; 

const PutAmoxarifado = async (id_producto, datos) => {
  try {
    const response = await api.put(`updateProductoAmoxarifado/${id_producto}`, datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al actualizar producto: ' + error.response.data.message);
    } else {
      throw new Error('Error al actualizar producto: ' + error.message);
    }
  }
};

const PostPatrimonio = async (datos) => {
  try {
    const response = await api.post('registroPatrimonio', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};


export {
  PostAmoxarifado, PostCategory, getCategoriasAmoxarifado, PostSubCategory, getOneSubCategoriasAmoxarifado, getHistorialDeposito,
  PostDeposito, getDepositoAmoxarifado, getOneProductoDeposito, getOneProductoDepositoView,getOneSerieDep, PostDepositoRandom, getProductoAmoxarifado, PutAmoxarifado, getStockAmoxarifado, getPrestamoAmoxarifado,
  PostPatrimonio
};
